import type {GridDimensions, GridSetup} from './types';

const SMALL = 400;
const MEDIUM = 750;

const GRID_SETUP_MATRIX: GridSetup[] = [
  // max 4 allowed
  {
    maxWidth: SMALL,
    dimensionsForMetrics: [
      {columns: 1, rows: 1},
      {columns: 2, rows: 1},
      {columns: 2, rows: 2},
      {columns: 2, rows: 2},
    ],
  },

  // max 8 allowed
  {
    maxWidth: MEDIUM,
    dimensionsForMetrics: [
      {columns: 1, rows: 1},
      {columns: 2, rows: 1},
      {columns: 3, rows: 1},
      {columns: 2, rows: 2},
      {columns: 3, rows: 2},
      {columns: 3, rows: 2},
      {columns: 4, rows: 2},
      {columns: 4, rows: 2},
    ],
  },

  // max 12 allowed for any larger
  {
    maxWidth: Number.MAX_SAFE_INTEGER,
    dimensionsForMetrics: [
      {columns: 1, rows: 1},
      {columns: 2, rows: 1},
      {columns: 3, rows: 1},
      {columns: 2, rows: 2},
      {columns: 3, rows: 2},
      {columns: 3, rows: 2},
      {columns: 4, rows: 2},
      {columns: 4, rows: 2},
      {columns: 5, rows: 2},
      {columns: 5, rows: 2},
      {columns: 6, rows: 2},
      {columns: 6, rows: 2},
    ],
  },
];

// need to make sure GRID_SETUP_MATRIX is sorted by maxWidth for getGridDimensions to work correctly
GRID_SETUP_MATRIX.sort((a, b) => a.maxWidth - b.maxWidth);

export function getGridDimensions(width: number, numMetrics: number): GridDimensions {
  if (numMetrics === 0) {
    return {columns: 0, rows: 0};
  }

  const setup = GRID_SETUP_MATRIX.find((setup) => width < setup.maxWidth);
  const numMetricsSupported = setup.dimensionsForMetrics.length;
  const metricIdx = Math.min(numMetricsSupported, numMetrics) - 1;

  return setup.dimensionsForMetrics[metricIdx];
}
